import { IOverviewStyleAndIconInfo, OverviewView } from './overview-view.model';

export enum EOverviewActionGroupingType {
  ERROR = 'ERROR',
  NOTIFY_BUILDING_SERVICE = 'NOTIFY BUILDING SERVICE',
  LOCKBOXFULL = 'LOCKBOXFULL',
  READYFORREVIEW = 'READYFORREVIEW',
}

export interface IOverviewAction extends OverviewView {
  readyForReview: boolean;
}

export interface IOverviewActionGroup {
  building: string;
  actions: IOverviewAction[];
}

export interface IOverviewActionWithStyle extends IOverviewAction {
  styles: IOverviewStyleAndIconInfo;
  cardNumber: string;
}

export interface IOverviewActionList {
  title: string;
  type: EOverviewActionGroupingType;
  show: boolean;
  list: IOverviewActionWithStyle[];
}

export interface IOverviewActionsFilter {
  searchValue: string;
  statusIds: string[];
  locationIds: number[];
}

export interface IActionSelectOptions {
  value: EOverviewActionGroupingType;
  label: string;
}
